
import React from "react";
import "./barcode.css";
import Barcode from 'react-barcode';

export default function BarcodePrint(props) {
  const { searchResult, componentRef, reactPrint } = props;

  // Helper to chunk array into pairs
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  // Duplicate each item for two stickers per row
  const duplicated = searchResult.flatMap(item => [item, item]);
  const rows = chunkArray(duplicated, 2);

  return (
    <div ref={componentRef}>
      {searchResult.length > 0 ? (
        <div>
          {rows.map((row, rowIdx) => (
            <div className="barcode-row" key={rowIdx} style={{ display: 'flex', flexDirection: 'row', marginBottom: '0mm', pageBreakInside: 'avoid' }}>
              {row.map((item, colIdx) => (
                <div className="barcode-label" key={colIdx} >
                  <span style={{ textAlign: 'center', width: '100%', fontWeight: '900', color: '#000' }}>{item.Book_Classification_No}{" "}{item.authorMark}</span>
                  <Barcode
                    width={2.5}
                    height={36}
                    margin={0}
                    fontSize={18}
                    value={item.Accession_No}
                    displayValue={true}
                  />
                </div>
              ))}
            </div>
          ))}
          <div className="col-md-2 text-center no-print" style={{ marginTop: '10px' }}>
            <button className='' onClick={reactPrint}>
              Print <i className="p2 fa fa-print " aria-hidden="true"></i>
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

